/* FROM THE FIELD rails + video modal (fc-from-the-field.liquid).
   Document-level delegation in capture phase so Impact's instant-nav DOM
   swaps cannot orphan the handlers. No globals. */
(function () {
  'use strict';

  var EPS = 4; /* scrollWidth can be fractional; naive end-detection never disables the arrow */

  function syncRail(rail) {
    var blk = rail.closest('.fcf-blk');
    if (!blk) return;
    var prog = blk.querySelector('[data-fcf-progress]');
    var max = rail.scrollWidth - rail.clientWidth;
    var atStart = rail.scrollLeft <= EPS;
    var atEnd = rail.scrollLeft >= max - EPS;
    if (prog) {
      var v = max <= 0 ? 1 : (atEnd ? 1 : Math.min(rail.scrollLeft / max, 1));
      prog.style.setProperty('--scroll-progress', v.toFixed(4));
    }
    blk.querySelectorAll('[data-fcf-nav]').forEach(function (b) {
      var d = parseInt(b.getAttribute('data-fcf-nav'), 10);
      b.disabled = max <= EPS || (d < 0 && atStart) || (d > 0 && atEnd);
    });
  }

  function syncAll() {
    document.querySelectorAll('[data-fcf-rail]').forEach(syncRail);
  }

  /* scroll does not bubble but is observable at the document in capture phase */
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.nodeType === 1 && e.target.hasAttribute && e.target.hasAttribute('data-fcf-rail')) {
      syncRail(e.target);
    }
  }, true);

  /* Native lazy-load is INTERMITTENT on this theme (verified: same page, same
     browser, images sometimes never pick a source even in-viewport). Kick the
     section's images to eager once the viewer is within ~900px, so deferral
     is kept but painting never depends on the browser's lazy heuristics. */
  var lazyIO = null;
  function forceEager(sec) {
    sec.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  function armLazyKicker() {
    var sections = document.querySelectorAll('.fcf');
    if (!sections.length) return;
    if (!('IntersectionObserver' in window)) { sections.forEach(forceEager); return; }
    if (!lazyIO) {
      lazyIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { forceEager(en.target); lazyIO.unobserve(en.target); }
        });
      }, { rootMargin: '900px 0px' });
    }
    sections.forEach(function (sec) {
      if (!sec.dataset.fcfLazyArmed) { sec.dataset.fcfLazyArmed = '1'; lazyIO.observe(sec); }
    });
  }

  function initAll() { syncAll(); armLazyKicker(); }
  window.addEventListener('resize', syncAll);
  window.addEventListener('load', initAll);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('pageshow', initAll);
  initAll();

  function closeModal(modal) {
    modal.hidden = true;
    var frame = modal.querySelector('[data-fcf-frame]');
    if (frame) frame.innerHTML = '';
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    var nav = t.closest ? t.closest('[data-fcf-nav]') : null;
    if (nav) {
      var blk = nav.closest('.fcf-blk');
      var rail = blk && blk.querySelector('[data-fcf-rail]');
      if (rail) {
        var dir = parseInt(nav.getAttribute('data-fcf-nav'), 10);
        /* instant, snap-aligned paging: smooth programmatic scrolls are
           cancelled by the theme's scroll machinery, and mandatory snap
           quantizes to card pitch anyway */
        var card = rail.querySelector('.fcf-card, .fcf-tile');
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
        var pitch = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
        var max = rail.scrollWidth - rail.clientWidth;
        var target = Math.round((rail.scrollLeft + rail.clientWidth * 0.82 * dir) / pitch) * pitch;
        rail.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: 'auto' });
        syncRail(rail);
      }
      return;
    }

    var film = t.closest ? t.closest('[data-fcf-film]') : null;
    if (film) {
      var section = film.closest('.fcf');
      var modal = section && section.querySelector('[data-fcf-modal]');
      if (!modal) return; /* no modal in DOM: let the link open YouTube */
      e.preventDefault();
      var id = film.getAttribute('data-fcf-film');
      var frame = modal.querySelector('[data-fcf-frame]');
      frame.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
        '?autoplay=1&rel=0" allow="accelerometer;autoplay;encrypted-media;picture-in-picture" allowfullscreen title="Video player"></iframe>';
      modal.querySelector('[data-fcf-mtitle]').textContent = film.getAttribute('data-fcf-title') || '';
      modal.querySelector('[data-fcf-mlink]').href = 'https://www.youtube.com/watch?v=' + encodeURIComponent(id);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      return;
    }

    var close = t.closest ? t.closest('[data-fcf-close]') : null;
    if (close) { closeModal(close.closest('[data-fcf-modal]')); return; }

    if (t.nodeType === 1 && t.hasAttribute && t.hasAttribute('data-fcf-modal') && !t.hidden) {
      closeModal(t);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-fcf-modal]').forEach(function (m) {
      if (!m.hidden) closeModal(m);
    });
  });
})();
